import React from "react";

function ContactDetailsStep({ handleChange }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="pt-3 mt-3">
          <h2 className="h6 color_grey mb-2">
            Finally, Tell Us About Yourself.
          </h2>
          <p className="nda__info mb-4">
            All the information you share in this section will be protected
            under a confidentiality agreement (NDA) and will not be shared with
            third-party individuals.
          </p>
        </div>

        <div className="col-lg-12">
          <div
            className="row row-cols-1 row-cols-sm-2 g-3 g-sm-4 pb-3 pb-sm-4 mb-xl-2"
            style={{ maxWidth: "600px" }}
          >
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> First Name
              </label>
              <input
                type="text"
                className="form-control form-control-lg form-icon-start"
                name="first-name"
                placeholder="Your first name.."
                onChange={handleChange}
              />
            </div>
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Last Name
              </label>
              <input
                type="text"
                className="form-control form-control-lg form-icon-start"
                name="last-name"
                placeholder="Your last name.."
                onChange={handleChange}
              />
            </div>
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Email Address
              </label>
              <input
                type="email"
                className="form-control form-control-lg form-icon-start"
                name="email"
                placeholder="example@domain.com"
                onChange={handleChange}
              />
            </div>
            <div className="col">
              <label className="form-label">Phone Number</label>
              <input
                type="text"
                className="form-control form-control-lg form-icon-start"
                name="contact-phone"
                placeholder="+1 123 456 789"
                onChange={handleChange}
              />
            </div>
            <div className="col">
              <label className="form-label">Company Name</label>
              <input
                type="text"
                className="form-control form-control-lg form-icon-start"
                name="company-name"
                placeholder="Company name.."
                onChange={handleChange}
              />
            </div>
            <div className="col">
              <label className="form-label">Company Website</label>
              <input
                type="text"
                className="form-control form-control-lg form-icon-start"
                name="company-web"
                placeholder="Website.."
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="form-check me-2">
            <input
              type="checkbox"
              className="form-check-input"
              name="accept-privacy"
              id="accept-privacy"
              onChange={handleChange}
            />
            <label htmlFor="accept-privacy" className="form-check-label">
              I have read, understood, and agree to the{" "}
              <a
                href="https://onexyazilim.com/en/about/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </label>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactDetailsStep;
